import React, { useRef } from 'react'
import FormHelperText from '@mui/material/FormHelperText'

/*
The admin-side twin of the seller app's `components/FieldFileInput` (medimny-web), so an upload looks
and behaves the same on both sides of the same feature: tap the camera, pick a file, and it is held
in the form as a base64 data URL for the API to push to S3. `preview` swaps the camera for a
thumbnail of what was picked, for fields where the picture itself is the content - the gift image on
a campaign is the one caller today.

One deliberate difference from the seller version: the error shows on `error` alone, not on
`touched && error`. A hidden file input never blurs, so `touched` stays false forever and the seller
version silently renders nothing - leaving a disabled Submit with no explanation. That is a bug worth
not copying.
*/
const FieldFileInput = (props) => {
    const { input: { onChange, value }, label, meta: { error } = {},
        accept = '.jpg, .png, .jpeg', preview = false } = props
    const inputFile = useRef(null)
    // A freshly picked file is a base64 data URL; a saved one comes back as its stored https URL.
    const showThumbnail = preview && typeof value === 'string'
        && (value.startsWith('data:image') || value.startsWith('http'))

    function handleFileSelect(e) {
        const file = e.target.files && e.target.files[0]
        if (!file) return
        const reader = new FileReader()
        reader.onload = () => onChange(reader.result)
        reader.readAsDataURL(file)
    }

    return (
        <div className='text-center'>
            <input
                type='file'
                accept={accept}
                style={{ display: 'none' }}
                onChange={(e) => handleFileSelect(e)} ref={inputFile}
            />
            {preview ?
                // Product-bank style: the file-select control (camera) with its label sits on the left
                // corner and the preview thumbnail shows to its right, both in the same row.
                <div className='d-flex align-items-center justify-content-between' style={{ gap: 16 }}>
                    <div className='text-center'>
                        <img alt={label}
                            src={value !== '' ? require('assets/images/camera_3.png') : require('assets/images/camera_1.png')}
                            className='d-block mx-auto cursor-pointer'
                            onClick={() => inputFile.current.click()} />
                        <label>{label}</label>
                    </div>
                    {showThumbnail &&
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <img alt={label} src={value} className='cursor-pointer'
                                style={{ borderStyle: 'solid', borderColor: '#dee2e6', borderWidth: 'thin', borderRadius: 10, padding: 10, width: 150, maxWidth: '100%', maxHeight: 150, objectFit: 'contain' }}
                                onClick={() => inputFile.current.click()} />
                            {/* Clearing the field makes the required validation fail, so Save stays
                                disabled until another image is picked. */}
                            <button type='button' onClick={() => onChange('')}
                                style={{ position: 'absolute', top: -6, right: -6, backgroundColor: 'transparent', color: 'red', border: 'none', width: 24, height: 24, textAlign: 'center', fontSize: 30, lineHeight: '20px', padding: 0, cursor: 'pointer' }}>
                                &times;
                            </button>
                        </div>}
                </div> :
                <div>
                    <img alt={label}
                        src={value !== '' ? require('assets/images/camera_3.png') : require('assets/images/camera_1.png')}
                        className='d-block mx-auto cursor-pointer'
                        onClick={() => inputFile.current.click()} />
                    <label>{label}</label>
                </div>}
            {error ? <FormHelperText style={{ color: '#f44336' }}>{error}</FormHelperText> : null}
        </div>
    )
}

export default FieldFileInput
